import * as actionTypes from './actionTypes'

export const processRules = (isOnload) => (dispatch) =>
  dispatch({ type: actionTypes.PROCESS_COND_RULES, payload: { isOnload } })
